import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ label, title, subtitle, testid }) => (
  <Reveal className="max-w-2xl mb-14 lg:mb-20">
    {label && <p className="label-caps mb-5">{label}</p>}
    <h2 data-testid={testid} className="font-display text-4xl sm:text-5xl lg:text-6xl font-normal leading-[1.05] text-[#FAFAFA]">
      {title}
    </h2>
    <div className="mt-6 h-px w-16 bg-gradient-to-r from-[#CBD5E1]/70 to-transparent" />
    {subtitle && <p className="mt-6 text-sm sm:text-base text-[#A1A1AA] leading-relaxed">{subtitle}</p>}
  </Reveal>
);
